const example = {
    attributes: {
        imageURL: EssentialBlocksLocalize?.image_url + "/gallery-images/china.jpg",
    },
};
export default example;
